"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _baseTheme = /*#__PURE__*/ _interop_require_default(require("./baseTheme"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var theme = function(param) {
    var fontFamily = (param === void 0 ? {
        fontFamily: "BentonSans Book"
    } : param).fontFamily;
    return (0, _baseTheme.default)({
        fontFamily: fontFamily
    });
};
var _default = theme;
